var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hello-world'),_c('our-services'),_c('why-to-work-with-us'),_c('our-work'),_c('markiting-sec'),_c('explore-more')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }